<template lang="">
  <IAmOverlay :loading="loading">
    <BCard>
      <b-nav pills>
        <b-nav-item
          :to="SYSTEM_CONFIGS_ROUTE_HASH.SYSTEM_CONFIGS"
          :active="$route.hash === SYSTEM_CONFIGS_ROUTE_HASH.SYSTEM_CONFIGS || $route.hash === ''"
        >
          <div class="d-flex-center">
            <IAmIcon
              icon="config"
              size="16"
            />
            <span class="d-none d-sm-inline">{{ $t('myAccount.systemConfigs.title') }}</span>
          </div>
        </b-nav-item>
        <b-nav-item
          :to="SYSTEM_CONFIGS_ROUTE_HASH.ERROR_MESSAGES"
          :active="$route.hash === SYSTEM_CONFIGS_ROUTE_HASH.ERROR_MESSAGES"
        >
          <div class="d-flex-center">
            <IAmIcon
              icon="infoCircleOutline"
              size="16"
            />
            <span class="d-none d-sm-inline">{{ $t('myAccount.systemConfigs.errorMessages.title') }}</span>
          </div>
        </b-nav-item>
      </b-nav>
      <div class="tab-content">
        <div
          :class="['tab-pane', { 'active': $route.hash === SYSTEM_CONFIGS_ROUTE_HASH.SYSTEM_CONFIGS || $route.hash === '' }]"
          class="p-0"
        >
          <i>To do</i>
        </div>
        <div
          :class="['tab-pane', { 'active': $route.hash === SYSTEM_CONFIGS_ROUTE_HASH.ERROR_MESSAGES }]"
          class="p-0"
        >
          <ErrorMessagesConfigs />
        </div>
      </div>
    </BCard>
  </IAmOverlay>
</template>
<script>
import { ref } from '@vue/composition-api'
import { BCard, BNav, BNavItem } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BNav,
    BNavItem,
    IAmOverlay: () => import('@/components/IAmOverlay.vue'),
    ErrorMessagesConfigs: () => import('@/views/apps/configs/system/error-messages/ErrorMessagesConfigs.vue'),
  },
  setup() {
    const loading = ref(false)

    const SYSTEM_CONFIGS_ROUTE_HASH = {
      SYSTEM_CONFIGS: '#',
      ERROR_MESSAGES: '#error-messages',
    }
    return {
      loading,
      SYSTEM_CONFIGS_ROUTE_HASH,
    }
  },
}
</script>
<style lang="">

</style>
